/**
 * Notification API types and functions.
 * These will be replaced by auto-generated Api.ts once `bun run generate-types` is run.
 */
import {
  apiGet,
  apiPut,
  type ErrorResponse,
  type FetchArgsOptions,
  type FetchResponse,
  getApiUrl,
} from "Infrastructure/Api/Api";

// --- Types ---

export enum NotificationType {
  SysAdmin_ActorWithdrawalRequested = "SysAdmin_ActorWithdrawalRequested",
  SysAdmin_PartnerRegistrationRequested = "SysAdmin_PartnerRegistrationRequested",
  SysAdmin_ActorRegistrationRequested = "SysAdmin_ActorRegistrationRequested",
  Partner_JobApprovedByActor = "Partner_JobApprovedByActor",
  Partner_JobRejectedByActor = "Partner_JobRejectedByActor",
}

export enum NotificationPriority {
  Low = "Low",
  Normal = "Normal",
  High = "High",
}

export type UserNotificationDto = {
  userNotificationID: string;
  type: NotificationType;
  priority: NotificationPriority;
  params: string | null;
  seenAt: string | null;
  readAt: string | null;
  dateCreated: string;
};

export type EntityListOfUserNotificationDto = {
  offset: number;
  limit: number;
  totalCount: number;
  items: UserNotificationDto[];
};

export type UnseenNotificationCountDto = {
  count: number;
};

// --- API Functions ---

const basePath = () => `/api/v1/user-notifications`;

export type GetUserNotificationsFetchResponse =
  | FetchResponse<EntityListOfUserNotificationDto, 200>
  | ErrorResponse;

export const getUserNotifications = (
  offset?: number,
  limit?: number,
  options?: FetchArgsOptions,
): Promise<GetUserNotificationsFetchResponse> => {
  return apiGet(`${getApiUrl()}${basePath()}`, options, {
    offset,
    limit,
  }) as Promise<GetUserNotificationsFetchResponse>;
};

export type GetUnseenCountFetchResponse =
  | FetchResponse<UnseenNotificationCountDto, 200>
  | ErrorResponse;

export const getUserNotificationsUnseenCount = (
  options?: FetchArgsOptions,
): Promise<GetUnseenCountFetchResponse> => {
  return apiGet(
    `${getApiUrl()}${basePath()}/unseen-count`,
    options,
  ) as Promise<GetUnseenCountFetchResponse>;
};

export type PutSeenFetchResponse = FetchResponse<void, 200> | ErrorResponse;

export const putUserNotificationsSeen = (
  options?: FetchArgsOptions,
): Promise<PutSeenFetchResponse> => {
  return apiPut(
    `${getApiUrl()}${basePath()}/seen`,
    undefined,
    options,
  ) as Promise<PutSeenFetchResponse>;
};

export type PutReadFetchResponse = FetchResponse<void, 200> | ErrorResponse;

export const putUserNotificationsRead = (
  userNotificationID: string,
  options?: FetchArgsOptions,
): Promise<PutReadFetchResponse> => {
  return apiPut(
    `${getApiUrl()}${basePath()}/${userNotificationID}/read`,
    undefined,
    options,
  ) as Promise<PutReadFetchResponse>;
};

export type PutReadAllFetchResponse = FetchResponse<void, 200> | ErrorResponse;

export const putUserNotificationsReadAll = (
  options?: FetchArgsOptions,
): Promise<PutReadAllFetchResponse> => {
  return apiPut(
    `${getApiUrl()}${basePath()}/read-all`,
    undefined,
    options,
  ) as Promise<PutReadAllFetchResponse>;
};

export type PutDismissFetchResponse = FetchResponse<void, 200> | ErrorResponse;

export const putUserNotificationsDismiss = (
  userNotificationID: string,
  options?: FetchArgsOptions,
): Promise<PutDismissFetchResponse> => {
  return apiPut(
    `${getApiUrl()}${basePath()}/${userNotificationID}/dismiss`,
    undefined,
    options,
  ) as Promise<PutDismissFetchResponse>;
};

export type PutDismissAllFetchResponse =
  | FetchResponse<void, 200>
  | ErrorResponse;

export const putUserNotificationsDismissAll = (
  options?: FetchArgsOptions,
): Promise<PutDismissAllFetchResponse> => {
  return apiPut(
    `${getApiUrl()}${basePath()}/dismiss-all`,
    undefined,
    options,
  ) as Promise<PutDismissAllFetchResponse>;
};
